import React from 'react';
import './LoadSpinner.css';

export const LoadSpinner = () => (
    <div className="lds-circle">
        <div></div>
    </div>
);